import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

function FirstChild(props) {
  const childrenArray = React.Children.toArray(props.children);
  return childrenArray[0] || null;
}

export default function AppearTransition({animation, children}) {
  return <ReactCSSTransitionGroup
    component={FirstChild}
    transitionName={{
      appear: animation
    }}
    transitionAppear={true}
    transitionAppearTimeout={5000}
    transitionEnterTimeout={5000}
    transitionLeaveTimeout={5000}
  >
    {children}
  </ReactCSSTransitionGroup>
}



// WEBPACK FOOTER //
// ./src/lib/AppearTransition.js